/**
 * Created by majid on 1/04/2021.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as jMoment from 'jalali-moment';
import * as moment from 'moment';

// Import our authentication service


@Injectable()
export class DateUtilService {

  constructor() {

  }


  public firstDayOfCurrentMonth(date){


    var today = this.jMomentFA(date);
    if (date)
      today = this.jMomentFA(date);

    const startOfMonth = today.startOf('month');

    return startOfMonth;
  }

  public lastDayOfCurrentMonth(date){

    var today = this.jMomentFA(date);
    if (date)
      today = this.jMomentFA(date);

    const endOfMonth   = today.endOf('month');

    return endOfMonth;
  }

  public weekDayName(date)
  {
    var weekDayName =  this.jMomentFA(date).format('dddd');
    return weekDayName;
  }

  public dayOfWeek(date)
  {

    let mdate = this.jMomentFA(date);
    return mdate.day();
  }


  public dayOfWeekPersian(date)
  {

    let mdate = this.jMomentFA(date);
    let dayNo =mdate.day()+1 ;
    if(dayNo==7)
      dayNo = 0;

    return dayNo ;
  }


  jMomentFA(date?)
  {
    let out = jMoment(date).locale('fa');
    return out ;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/date-service/DateUtilService.ts